<script>
export default {};
</script>

<template>
  <div>
    <!--start ABOUT US-->
    <section class="section bg-light" id="features">
      <div class="container">
        <div class="row vertical-content">
          <div class="col-lg-5">
            <div class="features-box">
              <h3>Atendimento Humanizado</h3>
              <p
                class="text-muted web-desc"
              >Você é atendido por pessoas. Temos uma equipe treinada e pronta pra ajudar você o mais rápido possível semrpe que você precisar.</p>
              <p class="text-muted web-desc">As vantagens de ser atendido por um humano de verdade garantem a você:</p>
              <ul class="text-muted list-unstyled margin-t-30 features-item-list">
                <li class>Um atendimento descomplicado, sem termos técnicos.</li>
                <li class>Nossa atenção dedicada ao seu problema, o que garante uma solução mais rápida.</li>
                <li class>Submit Your Orgnization.</li>
              </ul>
              <a href="javascript: void(0);" class="btn btn-custom margin-t-30 waves-effect waves-light" @click="this.$ilimitada.cadastrar">
                Eu quero contratar
                <i class="mdi mdi-arrow-right"></i>
              </a>
            </div>
          </div>
          <div class="col-lg-7">
            <div class="features-img features-right text-right">
              <img src="@/assets/images/online-world.svg" alt="macbook image" class="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--END ABOUT US-->
    <!--START WEBSITE-DESCRIPTION-->
    <section class="section section-lg bg-web-desc">
      <div class="bg-overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="text-white">Que tal fazer um teste de graça?</h2>
            <p
              class="padding-t-15 home-desc"
            >Nada melhor do que conferir com seus próprios olhos a qualidade do nosso IPTV, né?
            Por isso nós disponibilizamos 2 horas gratuitas - sem compromisso - pra você mesmo 
            avaliar a qualidade do nosso serviço.</p>
            <a
              href="javascript: void(0);"
              class="btn btn-bg-white margin-t-30 waves-effect waves-light mb-5"
              @click="this.$ilimitada.testar"
            >Eu quero fazer um teste!</a>
          </div>
        </div>
      </div>
      <div class="bg-pattern-effect">
        <img src="@/assets/images/bg-pattern.png" alt />
      </div>
    </section>

    <!--END WEBSITE-DESCRIPTION-->
  </div>
</template>